import { render } from "./AdminTeacherLeRreportT.vue?vue&type=template&id=66e3da6c&scoped=true"
import script from "./AdminTeacherLeRreportT.vue?vue&type=script&lang=js"
export * from "./AdminTeacherLeRreportT.vue?vue&type=script&lang=js"

import "./AdminTeacherLeRreportT.vue?vue&type=style&index=0&id=66e3da6c&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Private\\Edukatta_Private_Managment_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e3da6c"]])

export default __exports__